<template>
  <iSwitch
    :value="value"
    :disabled="disabled"
    :readonly="readonly"
    :class="$style.switch"
    size="large"
    @on-change="$emit('change', $event)"
  >
    <span
      v-if="trueLabel"
      slot="open"
      v-text="trueLabel"
    />
    <span
      v-if="falseLabel"
      slot="close"
      v-text="falseLabel"
    />
  </iSwitch>
</template>

<script>
export default {
  name: 'GdlSwitch',
  model: { prop: 'value', event: 'change' },
  props: {
    name: { type: String, required: true },
    value: { type: [String, Number, Boolean], default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    trueValue: { type: [String, Number, Boolean], default: true },
    falseValue: { type: [String, Number, Boolean], default: false },
    trueLabel: { type: String, default: undefined },
    falseLabel: { type: String, default: undefined },
  },
  computed: {
    isDisabled() {
      return this.readonly || this.disabled;
    },
  },
};
</script>

<style lang="scss" module>
.switch[readonly] {
  cursor: auto;
  pointer-events: none;
  &:after {
    cursor: auto;
  }
}
</style>
